<div class="card m-2 flex items-center justify-between">
  <div class="flex gap-2 items-center">
    <p-button icon="pi pi-bars" (onClick)="toggleSidebar()" />
    <span class="text-xl font-bold">
      <img src="assets/logo_4.png" alt="logo-icon" class="log" />
    </span>
  </div>
  <span class="flex gap-2 items-center">
    <!-- TODO: set initials -->
    <!-- <p-button
      [icon]="isDarkMode ? PrimeIcons.SUN : PrimeIcons.MOON"
      [outlined]="true"
      (onClick)="toggleTheme()"
    /> -->
    @if (totalNotificationCount() > 0) {
      <span
        class="notif-bell-wrap"
        (mouseenter)="showApprovalsPanel()"
        (mouseleave)="scheduleHideApprovalsPanel()"
      >
        <button
          type="button"
          class="notif-bell-btn"
          aria-label="Notifications"
        >
          <i class="pi pi-bell"></i>
          <span class="notif-bell-badge">
            {{ totalNotificationCount() > 99 ? '99+' : totalNotificationCount() }}
          </span>
        </button>

        @if (approvalsPanelOpen()) {
          <div class="notif-popover">
            <div class="px-3 py-2 border-b border-gray-200 flex items-center justify-between">
              <span class="text-sm font-semibold text-gray-800">Notifications</span>
              <span class="text-xs text-gray-500">
                Last {{ 15 }} days
              </span>
            </div>

            <!-- Pending approvals (manager-only) -->
            @if (pendingApprovalCount() > 0) {
              <div class="notif-section">
                <button
                  type="button"
                  class="notif-section-header"
                  [class.is-static]="!bothSectionsVisible()"
                  (click)="bothSectionsVisible() && togglePending()"
                >
                  <span class="flex items-center gap-2">
                    @if (bothSectionsVisible()) {
                      <i
                        class="pi text-[10px] text-gray-500"
                        [class.pi-chevron-down]="pendingExpanded()"
                        [class.pi-chevron-right]="!pendingExpanded()"
                      ></i>
                    }
                    <span class="text-xs font-semibold text-gray-700">
                      Pending Approvals
                    </span>
                  </span>
                  <span class="notif-count-pill bg-blue-50 text-blue-custom">
                    {{ pendingApprovalCount() }}
                    {{ pendingApprovalCount() === 1 ? 'user' : 'users' }}
                  </span>
                </button>

                @if (!bothSectionsVisible() || pendingExpanded()) {
                  <ul class="max-h-[260px] overflow-y-auto divide-y divide-gray-100 m-0 p-0 list-none">
                    @for (s of pendingSubmissions(); track s.userId) {
                      <li class="px-3 py-2">
                        <div class="flex items-center justify-between">
                          <span class="text-sm font-medium text-gray-800 truncate">
                            {{ s.userName }}
                          </span>
                          <span class="text-[11px] text-gray-500 ml-2 whitespace-nowrap">
                            {{ s.dates.length }}
                            {{ s.dates.length === 1 ? 'day' : 'days' }}
                          </span>
                        </div>
                        <div class="text-xs text-gray-500 mt-0.5">
                          {{ formatDateRange(s.dates) }}
                        </div>
                      </li>
                    }
                  </ul>

                  <div class="px-3 py-2 border-t border-gray-100 text-right">
                    <button
                      type="button"
                      class="text-xs text-blue-custom hover:underline cursor-pointer bg-transparent border-0 p-0"
                      (click)="goToMyTeam()"
                    >
                      View all in My Team →
                    </button>
                  </div>
                }
              </div>
            }

            <!-- Rejected entries (visible to anyone with rejected days) -->
            @if (rejectedDayCount() > 0) {
              <div
                class="notif-section"
                [class.notif-section-divider]="pendingApprovalCount() > 0"
              >
                <button
                  type="button"
                  class="notif-section-header"
                  [class.is-static]="!bothSectionsVisible()"
                  (click)="bothSectionsVisible() && toggleRejected()"
                >
                  <span class="flex items-center gap-2">
                    @if (bothSectionsVisible()) {
                      <i
                        class="pi text-[10px] text-gray-500"
                        [class.pi-chevron-down]="rejectedExpanded()"
                        [class.pi-chevron-right]="!rejectedExpanded()"
                      ></i>
                    }
                    <span class="text-xs font-semibold text-gray-700">
                      Rejected Entries
                    </span>
                  </span>
                  <span class="notif-count-pill bg-red-50 text-red-600">
                    {{ rejectedDayCount() }}
                    {{ rejectedDayCount() === 1 ? 'day' : 'days' }}
                  </span>
                </button>

                @if (!bothSectionsVisible() || rejectedExpanded()) {
                  <ul class="max-h-[260px] overflow-y-auto divide-y divide-gray-100 m-0 p-0 list-none">
                    @for (r of rejectedEntries(); track r.taskDate) {
                      <li class="px-3 py-2">
                        <div class="flex items-center justify-between">
                          <span class="text-sm font-medium text-gray-800">
                            {{ formatShortDate(r.taskDate) }}
                          </span>
                          @if (r.approvedByName) {
                            <span class="text-[11px] text-gray-500 ml-2 whitespace-nowrap">
                              by {{ r.approvedByName }}
                            </span>
                          }
                        </div>
                        @if (r.comments) {
                          <div
                            class="text-xs text-gray-500 mt-0.5"
                            [pTooltip]="r.comments"
                            tooltipPosition="left"
                          >
                            {{ r.comments }}
                          </div>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
        }
      </span>
    }

    <button
      [pTooltip]="'User Information'"
      tooltipPosition="bottom"
      type="button"
      (click)="openUserMenu()"
      style="border: none; background: none; padding: 0; cursor: pointer"
    >
      <p-avatar [label]="initials()" shape="circle" />
    </button>

    <p-menu #menu [popup]="true" [model]="items"></p-menu>
    <p-button [icon]="PrimeIcons.SIGN_OUT" (onClick)="userService.logout()" />
  </span>
</div>
